export const pt = {
  brand: "Ads Library Downloader",
  nav: {
    dashboard: "Biblioteca",
    history: "Histórico",
    export: "Exportar",
    settings: "Configurações",
    extension: "Extensão",
    logout: "Sair",
  },
  library: {
    tagline: "Todos os seus anúncios em um só lugar",
    search: "Buscar anúncios, marcas, textos…",
    activeAds: "Anúncios ativos",
    platforms: "Plataformas",
    brands: "Marcas",
    asset: "Mídia",
    sort: "Ordenar",
    display: "Layout",
    tags: "Tags",
    days: "dias",
    day: "dia",
    active: "Ativo",
    savedAgo: "Salvo há {n} {unit}",
    empty: "Sua biblioteca está vazia. Instale a extensão e clique SAVE em qualquer anúncio da Meta Ad Library para começar.",
    adLibrary: "Ad Library",
    landing: "Landing page",
    boards: "BOARDS",
  },
  auth: {
    signInTitle: "Entrar",
    signInSubtitle: "Acesse seu painel de downloads da Biblioteca de Anúncios.",
    signUpTitle: "Criar conta",
    signUpSubtitle: "Comece a organizar seus criativos em minutos.",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    signIn: "Entrar",
    signUp: "Criar conta",
    noAccount: "Não tem conta?",
    hasAccount: "Já tem conta?",
    createOne: "Criar conta",
    signInNow: "Entrar",
    forgot: "Esqueci a senha",
    welcomeBack: "Bem-vindo de volta!",
    accountCreated: "Conta criada com sucesso!",
  },
  stats: {
    totalDownloads: "Downloads totais",
    images: "Imagens",
    videos: "Vídeos",
    monitoredAds: "Anúncios monitorados",
    advertisers: "Anunciantes",
    countries: "Países",
  },
  history: {
    title: "Histórico de downloads",
    subtitle: "Filtre, pesquise e rebaixe qualquer criativo já capturado.",
    search: "Buscar anúncio, headline, arquivo…",
    advertiser: "Anunciante",
    country: "País",
    type: "Tipo",
    date: "Data",
    file: "Arquivo",
    actions: "Ações",
    all: "Todos",
    image: "Imagem",
    video: "Vídeo",
    redownload: "Rebaixar",
    empty: "Nenhum download registrado ainda. Instale a extensão para começar.",
    filters: "Filtros",
  },
  export: {
    title: "Exportação",
    subtitle: "Exporte seu histórico e criativos em CSV, JSON ou ZIP.",
    csv: "Baixar CSV",
    json: "Baixar JSON",
    zip: "Baixar ZIP (metadados + mídias)",
    zipHint: "O ZIP inclui um metadata.json e as mídias organizadas em Marca/Campanha/[imagens|videos].",
  },
  settings: {
    title: "Configurações",
    subtitle: "Preferências pessoais para a extensão e o painel.",
    defaultFolder: "Pasta padrão",
    parallelLimit: "Downloads simultâneos",
    namingTemplate: "Modelo de nome",
    autoRetry: "Retry automático",
    maxRetries: "Máx. de tentativas",
    language: "Idioma",
    theme: "Tema",
    themeLight: "Claro",
    themeDark: "Escuro",
    save: "Salvar",
    saved: "Configurações salvas.",
  },
  extension: {
    title: "Extensão do Chrome",
    subtitle: "Instale a extensão e conecte ao seu painel em 3 passos.",
    step1: "Baixe o pacote da extensão (.zip) e extraia em uma pasta.",
    step2: "Acesse chrome://extensions, ative o Modo do desenvolvedor e clique em Carregar sem compactação.",
    step3: "No popup da extensão, cole a URL da API e o Token de acesso abaixo e ative Sincronizar histórico.",
    download: "Baixar extensão (.zip)",
    apiUrl: "URL da API",
    token: "Token de acesso",
    copy: "Copiar",
    copied: "Copiado!",
    version: "Versão",
  },
  common: {
    loading: "Carregando…",
    filter: "Filtrar",
    clear: "Limpar",
    all: "Todos",
    close: "Fechar",
  },
};
